<template>
	<div>
		<h1 v-if="$router.message" class="text-center">{{ $router.message }}</h1>
		<h1 v-else class="text-center">You've reached this page because of an error.</h1>
		<button class="btn btn-success centered-button uppercase" @click="routeToLogin()">Return to Login</button>
	</div>
</template>

<script>
export default {
	data () {
		return {}
	},
	props: {
		message: {
			type: String,
			default: ''
		}
	},
	methods: {
		/**
		 * To reroute to the login screen.
		 * @function
		 * @returns {undefined}
		 */
		routeToLogin () {
			this.$router.message = ''
			this.$router.push('/login')
		}
	}
}
</script>


// WEBPACK FOOTER //
// Error.vue?2363a87f